
<div style="position: relative">
    <c-card-iterator
        :items          = "filteredItems"
        :label          = "$t('todo.delay.title')"
        :loading        = "loading"
        :title-prefix   = "true"
        :pagination-on  = "true"
        :item-height    = "76"
        :min-height     = "topHeight"
        :filter         = "match"
        :filter-height  = "72"
        :height         = "height"
        @search         = "onSearch"
    >
        <template v-slot:filter>
            <div>
                <v-switch
                    class="mt-3 pt-0"
                    v-model = "scheduled"
                    label   = "ZÜS Prüfungen mit geplanten Termin anzeigen"
                    :ripple = "false"
                    hide-details
                    dense
                    @change = "onScheduled"
                />
            </div>
        </template>
        <template v-slot:card="{ item }">
            <p-inc-assessment-delay-card
                :item = "item"
                @site = "onSite"
            />
        </template>
    </c-card-iterator>

    <div v-if="(!items || items.length === 0) && !loading" class="lm-border empty-todos">
        <v-icon color="success" size="30">mdi-check-circle</v-icon>
    </div>
</div>
